// extracted by mini-css-extract-plugin
export default {"container":"Dn-z","bubbleNav":"En-z","graphic":"Fn-z","contact":"Gn-z"};